import React, { Component } from "react";
import {
  DatePicker,
  Select,
  Radio,
  Space,
  Checkbox,
  message,
  Spin,
  Input
} from "antd";
import Bridge from "../../utils/Bridge";
import dayjs from "dayjs";
import { logEvent } from "../../utils/analytics";
const {TextArea} =Input;


const { Option } = Select;

export default class MedicalHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smoking_history: "",
      allergies: [
        {
          id: 1,
          name: "",
        },
      ],
      prescriptions: [
        {
          id: 1,
          name: "",
          dose: "",
          frequency: "",
          frequency_type: "",
          date_started: "",
          reason: "",
          units: "",
          unit_type: "",
          route: "",
          route_type: "",
        },
      ],
      surgeries: [
        {
          id: 1,
          type: "",
          location: "",
          date: "",
        },
      ],
      diagnosed_hair_loss: "",
      anything_apply_to_you: [],
      loading: false,
      have_you_quit_smoking_in_the_past_year: "",
      do_you_have_allergies: "",
      // history
      bipolar_disorder: "",
      brain_aneurysm: "",
      cancer: "",
      depression: "",
      diabetes: "",
      epilepsy: "",
      muscle_disease: "",
      schizophrenia: "",
      migraines: "",

      adhd: "",
      anxiety: "",
      asthma:"",
      autism_spectrum_disorder: "",
      cognitive_impairment: "",
      concussion: "",
      copd:"",
      dementia: "",
      other_history_option:"",
      other_history_specification:"",

      participant_type:[],
      participant_type_als:"",
      participant_type_any_other_neurologic_diagnosis:"",
      participant_type_any_other_neurologic_diagnosis_other_specification:"",

      ecas_user_type:"",
      do_you_have_surgeries:"",
      do_you_have_prescription:""
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
    this.get_ecas_user_type()
  }
  get_ecas_user_type=()=>{
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.get_ecas_user_type(params)
      .then((response) => {
        if (response.status == "1") {
          this.setState({ecas_user_type:response.data})
        }
      })
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.ecas_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Smoking History") {
                this.setState({
                  smoking_history: item.value ? item.value : "",
                });
              }
              if (item.field == "Have you quit smoking in the past year?") {
                this.setState({
                  have_you_quit_smoking_in_the_past_year: item.value
                    ? item.value
                    : "",
                });
              }
              if (item.field == "Do you have any surgeries?") {
                this.setState({do_you_have_surgeries: item.value})
              }
              if (item.field == "Do you have any allergies?") {
                this.setState({
                  do_you_have_allergies: item.value ? item.value : "",
                });
              }
              if (item.field == "Allergies") {
                this.setState({
                  allergies: item.value
                    ? JSON.parse(item.value)
                    : [
                        {
                          id: 1,
                          name: "",
                        },
                      ],
                });
              }
              if (item.field == "Do you have any current prescriptions?") {
                console.log('item',item.value);
                
                this.setState({
                  do_you_have_prescription: item.value ? item.value : "No",
                });
              }
              if (item.field == "Prescriptions") {
                let prescriptions = item.value
                  ? JSON.parse(item.value)
                  : [
                      {
                        id: 1,
                        name: "",
                        dose: "",
                        frequency: "",
                        frequency_type: "",
                        date_started: "",
                        reason: "",
                        units: "",
                        unit_type: "",
                        route: "",
                        route_type: "",
                      },
                    ];
                let p_arr = [];
                for (let pitem of prescriptions) {
                  if (pitem.date_started) {
                    pitem.date_started = dayjs(pitem.date_started);
                  }
                  p_arr.push(pitem);
                }
                this.setState({
                  prescriptions: item.value ? p_arr : [],
                });
              }
              if (item.field == "Surgeries") {
                let surgeries = item.value
                  ? JSON.parse(item.value)
                  : [
                      {
                        id: 1,
                        type: "",
                        location: "",
                        date: "",
                      },
                    ];
                let s_arr = [];
                for (let sitem of surgeries) {
                  if (sitem.date) {
                    sitem.date = dayjs(sitem.date);
                  }
                  s_arr.push(sitem);
                }
                this.setState({
                  surgeries: item.value ? s_arr : [],
                });
              }
              if (item.field == "Anything apply to you?") {
                this.setState({
                  anything_apply_to_you: item.value
                    ? JSON.parse(item.value)
                    : [],
                });
              }
              if (item.field == "ADHD/ADD") {
                this.setState({
                  adhd: item.value ? item.value : "",
                });
              }
              if (item.field == "Anxiety") {
                this.setState({
                  anxiety: item.value ? item.value : "",
                });
              }
              if (item.field == "Asthma") {
                this.setState({
                  asthma: item.value ? item.value : "",
                });
              }
              if (item.field == "Autism Spectrum Disorder") {
                this.setState({
                  autism_spectrum_disorder: item.value ? item.value : "",
                });
              }
              if (item.field == "Bipolar Disorder") {
                this.setState({
                  bipolar_disorder: item.value ? item.value : "",
                });
              }
              if (item.field == "Brain Aneurysm") {
                this.setState({
                  brain_aneurysm: item.value ? item.value : "",
                });
              }
              if (item.field == "Cancer") {
                this.setState({
                  cancer: item.value ? item.value : "",
                });
              }
              if (item.field == "Cognitive Impairment") {
                this.setState({
                  cognitive_impairment: item.value ? item.value : "",
                });
              }
              if (item.field == "Concussion (s)") {
                this.setState({
                  concussion: item.value ? item.value : "",
                });
              }
              if (item.field == "COPD") {
                this.setState({
                  copd: item.value ? item.value : "",
                });
              }
              if (item.field == "Dementia") {
                this.setState({
                  dementia: item.value ? item.value : "",
                });
              }
              if (item.field == "Depression") {
                this.setState({
                  depression: item.value ? item.value : "",
                });
              }
              if (item.field == "Diabetes") {
                this.setState({
                  diabetes: item.value ? item.value : "",
                });
              }
              if (item.field == "Epilepsy") {
                this.setState({
                  epilepsy: item.value ? item.value : "",
                });
              }
              if (item.field == "Muscle Disease") {
                this.setState({
                  muscle_disease: item.value ? item.value : "",
                });
              }
              if (item.field == "Migraines") {
                this.setState({
                  migraines: item.value ? item.value : "",
                });
              }
              if (item.field == "Schizophrenia") {
                this.setState({
                  schizophrenia: item.value ? item.value : "",
                });
              }
              if (item.field == "History of Other") {
                console.log('History of Other item.value',item.value)
                this.setState({
                  other_history_option: item.value ? item.value : "",
                });
              }
              if (item.field == "History of Other Specification") {
                console.log('item.value',item.value)
                this.setState({
                  other_history_specification: item.value ? item.value : "",
                });
              }
              if (item.field == "Participant Type") {
                this.setState({
                  participant_type: item.value
                    ? JSON.parse(item.value)
                    : [],
                });
              }
              if (item.field == "Participant Type - ALS") {
                this.setState({
                  participant_type_als: item.value ? item.value : "",
                });
              }
              if (item.field == "Participant Type - Any other Neurologic diagnosis") {
                this.setState({
                  participant_type_any_other_neurologic_diagnosis: item.value ? item.value : "",
                });
              }
              if (item.field == "Participant Type - Any other Neurologic diagnosis Specification") {
                console.log('item',item.value)
                this.setState({
                  participant_type_any_other_neurologic_diagnosis_other_specification: item.value ? item.value : "",
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  save = (goToNextStep = true) => {
    if (goToNextStep) {
      if (!this.state.smoking_history) {
        message.warning("Please select 'Smoking History'");
        return;
      }
      if (!this.state.have_you_quit_smoking_in_the_past_year) {
        message.warning("Please select 'Have you quit smoking in the past year?'");
        return;
      }
      if (!this.state.do_you_have_allergies) {
        message.warning("Please select Do you have any allergies?");
        return;
      }
      if (this.state.do_you_have_allergies == "Yes") {
        if (this.state.allergies.length === 0) {
          message.warning("Please add allergy");
          return;
        }
        if (this.state.allergies.length > 0) {
          let list = this.state.allergies;
          for (let item of list) {
            if (!item.name) {
              message.warning("Please enter allergy name");
              return;
            }
          }
        }
      }
      if (!this.state.do_you_have_prescription) {
        message.warning("Please select do you have prescription");
        return;
      }
      if(this.state.do_you_have_prescription=='Yes'){
        if(this.state.prescriptions.length==0){
          message.warning("Please add Prescription");
          return;
        }
        if (this.state.prescriptions.length > 0) {
          let list = this.state.prescriptions;
          for (let item of list) {
            if (!item.name) {
              message.warning("Please enter Prescription name");
              return;
            }
          }
        }
      }
      if(this.state.do_you_have_surgeries=='Yes'){
        if (this.state.surgeries.length === 0) {
          message.warning("Please add surgery name");
          return;
        }
        if (this.state.surgeries.length > 0) {
          let list = this.state.surgeries;
          for (let item of list) {
            if (!item.type) {
              message.warning("Please enter Surgery Type");
              return;
            }
            if (!item.location) {
              message.warning("Please enter Surgery Location.");
              return;
            }
            if (!item.date) {
              message.warning("Please select Surgery Year.");
              return;
            }
          }
        }
      }
      let validation_arr=[
        {label:"ADHD",state_name:"adhd"},
        {label:"Anxiety",state_name:"anxiety"},
        {label:"Asthma",state_name:"asthma"},
        {label:"Autism Spectrum Disorder",state_name:"autism_spectrum_disorder"},
        {label:"Bipolar Disorder",state_name:"bipolar_disorder"},
        {label:"Brain Aneurysm",state_name:"brain_aneurysm"},
        {label:"Cancer",state_name:"cancer"},
        {label:"Cognitive Impairment",state_name:"cognitive_impairment"},
        {label:"Concussion",state_name:"concussion"},
        {label:"COPD",state_name:"copd"},
        {label:"Dementia",state_name:"dementia"},
        {label:"Depression",state_name:"depression"},
        {label:"Diabetes",state_name:"diabetes"},
        {label:"Epilepsy",state_name:"epilepsy"},
        {label:"Muscle Disease",state_name:"muscle_disease"},
        {label:"Migraines",state_name:"migraines"},
        {label:"Schizophrenia",state_name:"schizophrenia"},
        {label:"Other History Option",state_name:"other_history_option"},
      ]
      for(let item of validation_arr){
        if(!this.state[item.state_name]){
          message.warning("Please select option of "+item.label+" field");
          return;
        }
      }
      if(this.state.other_history_option=="Yes"){
        if(!this.state.other_history_specification){
          message.warning("Please enter Other History Specification");
          return;
        }
      }
      if(this.state.participant_type.length==0){
        message.warning("Please select participant type");
        return;
      }
    }
    const saveForLater = !goToNextStep;

    let missingFields = [];
    if (!this.state.smoking_history) missingFields.push("Smoking History");
    if (!this.state.have_you_quit_smoking_in_the_past_year) missingFields.push("Have you quit smoking in the past year?");
    if (!this.state.do_you_have_allergies) missingFields.push("Do you have any allergies?");
    else if (this.state.do_you_have_allergies === "Yes") {
      if (this.state.allergies.length === 0 || this.state.allergies.some(a => !a.name)) missingFields.push("Allergies List");
    }
    if (!this.state.do_you_have_prescription) missingFields.push("Do you have any current prescriptions?");
    else if (this.state.do_you_have_prescription === "Yes") {
      if (this.state.prescriptions.length === 0 || this.state.prescriptions.some(p => !p.name)) missingFields.push("Prescriptions List");
    }
    if (this.state.do_you_have_surgeries === "Yes") {
      if (this.state.surgeries.length === 0 || this.state.surgeries.some(s => !s.type || !s.location || !s.date)) missingFields.push("Surgeries List");
    }
    let missing_validation_arr=[
      {label:"ADHD",state_name:"adhd"},
      {label:"Anxiety",state_name:"anxiety"},
      {label:"Asthma",state_name:"asthma"},
      {label:"Autism Spectrum Disorder",state_name:"autism_spectrum_disorder"},
      {label:"Bipolar Disorder",state_name:"bipolar_disorder"},
      {label:"Brain Aneurysm",state_name:"brain_aneurysm"},
      {label:"Cancer",state_name:"cancer"},
      {label:"Cognitive Impairment",state_name:"cognitive_impairment"},
      {label:"Concussion",state_name:"concussion"},
      {label:"COPD",state_name:"copd"},
      {label:"Dementia",state_name:"dementia"},
      {label:"Depression",state_name:"depression"},
      {label:"Diabetes",state_name:"diabetes"},
      {label:"Epilepsy",state_name:"epilepsy"},
      {label:"Muscle Disease",state_name:"muscle_disease"},
      {label:"Migraines",state_name:"migraines"},
      {label:"Schizophrenia",state_name:"schizophrenia"},
      {label:"Other History Option",state_name:"other_history_option"},
    ];
    for(let item of missing_validation_arr){
      if(!this.state[item.state_name]){
        missingFields.push(item.label);
      }
    }
    if(this.state.other_history_option === "Yes" && !this.state.other_history_specification){
      missingFields.push("Other History Specification");
    }
    if(this.state.participant_type.length === 0){
      missingFields.push("Participant Type");
    }

    const isMedicalHistoryComplete = missingFields.length === 0 ? 1 : 0;

    let questions = [
      ...(saveForLater
        ? [
            {
              parent_field: "Save",
              field: "Save for later date",
              value: dayjs().format("MM/DD/YYYY HH:mm"),
            },
          ]
        : []),
      {
        parent_field: "Medical History Save Type",
        field: "Medical History Save Type",
        value: saveForLater ? "Save for Later" : "Save Medical History",
      },
      {
        parent_field: "Is Medical History Fields Submitted",
        field: "Is Medical History Fields Submitted",
        value: isMedicalHistoryComplete,
      },
      {
        parent_field: "Medical History Missing Fields",
        field: "Medical History Missing Fields",
        value: JSON.stringify(missingFields),
      },
      {
        parent_field: "Smoking History",
        field: "Smoking History",
        value: this.state.smoking_history,
      },
      {
        parent_field: "Have you quit smoking in the past year?",
        field: "Have you quit smoking in the past year?",
        value: this.state.have_you_quit_smoking_in_the_past_year,
      },
      {
        parent_field: "Do you have any allergies?",
        field: "Do you have any allergies?",
        value: this.state.do_you_have_allergies,
      },
      {
        parent_field: "Allergies",
        field: "Allergies",
        value: JSON.stringify(this.state.allergies),
      },
      {
        parent_field: "Do you have any current prescriptions?",
        field: "Do you have any current prescriptions?",
        value: this.state.do_you_have_prescription ? this.state.do_you_have_prescription : "No",
      },
      {
        parent_field: "Prescriptions",
        field: "Prescriptions",
        value: JSON.stringify(this.state.prescriptions),
      },
      {
        parent_field:"Do you have any surgeries?",
        field:"Do you have any surgeries?",
        value: this.state.do_you_have_surgeries
      },
      {
        parent_field: "Surgeries",
        field: "Surgeries",
        value: JSON.stringify(this.state.surgeries),
      },
      {
        parent_field: "ADHD/ADD",
        field: "ADHD/ADD",
        value: this.state.adhd ? this.state.adhd : "",
      },
      {
        parent_field: "Anxiety",
        field: "Anxiety",
        value: this.state.anxiety ? this.state.anxiety : "",
      },
      {
        parent_field: "Asthma",
        field: "Asthma",
        value: this.state.asthma ? this.state.asthma : "",
      },
      {
        parent_field: "Autism Spectrum Disorder",
        field: "Autism Spectrum Disorder",
        value: this.state.autism_spectrum_disorder ? this.state.autism_spectrum_disorder : "",
      },
      {
        parent_field: "Bipolar Disorder",
        field: "Bipolar Disorder",
        value: this.state.bipolar_disorder ? this.state.bipolar_disorder : "",
      },
      {
        parent_field: "Brain Aneurysm",
        field: "Brain Aneurysm",
        value: this.state.brain_aneurysm ? this.state.brain_aneurysm : "",
      },
      {
        parent_field: "Cancer",
        field: "Cancer",
        value: this.state.cancer ? this.state.cancer : "",
      },
      {
        parent_field: "Cognitive Impairment",
        field: "Cognitive Impairment",
        value: this.state.cognitive_impairment ? this.state.cognitive_impairment : "",
      },
      {
        parent_field: "Concussion (s)",
        field: "Concussion (s)",
        value: this.state.concussion ? this.state.concussion : "",
      },
      {
        parent_field: "COPD",
        field: "COPD",
        value: this.state.copd ? this.state.copd : "",
      },
      {
        parent_field: "Dementia",
        field: "Dementia",
        value: this.state.dementia ? this.state.dementia : "",
      },
      {
        parent_field: "Depression",
        field: "Depression",
        value: this.state.depression ? this.state.depression : "",
      },
      {
        parent_field: "Diabetes",
        field: "Diabetes",
        value: this.state.diabetes ? this.state.diabetes : "",
      },
      {
        parent_field: "Epilepsy",
        field: "Epilepsy",
        value: this.state.epilepsy ? this.state.epilepsy : "",
      },
      {
        parent_field: "Muscle Disease",
        field: "Muscle Disease",
        value: this.state.muscle_disease ? this.state.muscle_disease : "",
      },
      {
        parent_field: "Migraines",
        field: "Migraines",
        value: this.state.migraines ? this.state.migraines : "",
      },
      {
        parent_field: "Schizophrenia",
        field: "Schizophrenia",
        value: this.state.schizophrenia ? this.state.schizophrenia : "",
      },
      {
        parent_field: "History of Other",
        field: "History of Other",
        value: this.state.other_history_option ? this.state.other_history_option : "",
      },
      {
        parent_field: "History of Other Specification",
        field: "History of Other Specification",
        value: this.state.other_history_specification,
      },
      {
        parent_field: "Participant Type",
        field: "Participant Type",
        value: JSON.stringify(this.state.participant_type),
      },
      {
        parent_field: "Participant Type - ALS",
        field: "Participant Type - ALS",
        value: this.state.participant_type_als,
      },
      {
        parent_field: "Participant Type - Any other Neurologic diagnosis",
        field: "Participant Type - Any other Neurologic diagnosis",
        value: this.state.participant_type_any_other_neurologic_diagnosis,
      },
      {
        parent_field: "Participant Type - Any other Neurologic diagnosis Specification",
        field: "Participant Type - Any other Neurologic diagnosis Specification",
        value: this.state.participant_type_any_other_neurologic_diagnosis_other_specification,
      }
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "5",
      action_type: this.props.is_update == true ? "update" : "insert",
      ...(saveForLater && { save_for_later: true }),
    };
    this.setState({ loading: true });
    Bridge.demographics.ecas_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_saved", { section: "medical_history" });
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                // if (goToNextStep) {
                  if(this.state.ecas_user_type==1){
                    this.props.set_active_step(6);
                  }else{
                    this.props.set_active_step(7);
                  }
                // }
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeApplyFor = (e) => {
    let value = e.target.value;
    let tempArr = this.state.anything_apply_to_you;
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ anything_apply_to_you: newArray });
    } else {
      tempArr.push(value);
      this.setState({ anything_apply_to_you: tempArr });
    }
  };
  onChangeAllergy = (e) => {
  };
  getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  add_new_allergy = () => {
    let arr = this.state.allergies;
    const randomInteger = this.getRandomInt(1, 2000);
    let obj = {
      id: randomInteger,
      name: "",
    };
    arr.push(obj);
    this.setState({ allergies: arr });
  };
  remove_allergy = (id) => {
    let arr = this.state.allergies;
    let tempArr = [];
    for (let single of arr) {
      if (single.id != id) {
        tempArr.push(single);
      }
    }
    this.setState({ allergies: tempArr });
  };
  update_allergy = (event, item) => {
    let arr = this.state.allergies;
    let tempArr = [];
    for (let single of arr) {
      if (single.id == item.id) {
        single.name = event.target.value;
      }
      tempArr.push(single);
    }
    this.setState({ allergies: tempArr });
  };
  add_new_prescription = () => {
    let arr = this.state.prescriptions;
    const randomInteger = this.getRandomInt(1, 2000);
    let obj = {
      id: randomInteger,
      name: "",
      dose: "",
      frequency: "",
      date_started: "",
    };
    arr.push(obj);
    this.setState({ prescriptions: arr });
  };
  remove_prescription = (id) => {
    let arr = this.state.prescriptions;
    let tempArr = [];
    for (let single of arr) {
      if (single.id != id) {
        tempArr.push(single);
      }
    }
    this.setState({ prescriptions: tempArr });
  };
  update_prescription = (event, item, field) => {
    let arr = this.state.prescriptions;
    let tempArr = [];
    for (let single of arr) {
      if (single.id == item.id) {
        if (field == "name") {
          single.name = event.target.value;
        }
        if (field == "dose") {
          single.dose = event.target.value;
        }
        if (field == "units") {
          single.units = event.target.value;
        }
        if (field == "unit_type") {
          single.unit_type = event.target.value;
        }
        if (field == "route") {
          single.route = event.target.value;
        }
        if (field == "route_type") {
          single.route_type = event.target.value;
        }
        if (field == "frequency") {
          single.frequency = event.target.value;
        }
        if (field == "frequency_type") {
          single.frequency_type = event.target.value;
        }
        if (field == "date_started") {
          single.date_started = event;
        }
        if (field == "reason") {
          single.reason = event.target.value;
        }
      }
      tempArr.push(single);
    }
    this.setState({ prescriptions: tempArr });
  };
  add_new_surgery = () => {
    let arr = this.state.surgeries;
    const randomInteger = this.getRandomInt(1, 2000);
    let obj = {
      id: randomInteger,
      type: "",
      location: "",
      date: "",
    };
    arr.push(obj);
    this.setState({ surgeries: arr });
  };
  update_surgery = (event, item, field) => {
    let arr = this.state.surgeries;
    let tempArr = [];
    for (let single of arr) {
      if (single.id == item.id) {
        if (field == "type") {
          single.type = event.target.value;
        }
        if (field == "location") {
          single.location = event.target.value;
        }
        if (field == "date") {
          single.date = event;
        }
      }
      tempArr.push(single);
    }
    this.setState({ surgeries: tempArr });
  };
  remove_surgery = (id) => {
    let arr = this.state.surgeries;
    let tempArr = [];
    for (let single of arr) {
      if (single.id != id) {
        tempArr.push(single);
      }
    }
    this.setState({ surgeries: tempArr });
  };
  onChangeDiagnosedHairLoss = (event) => {
    this.setState({ diagnosed_hair_loss: event.target.value });
  };
  onChangeParticipantType = (e) => {
    let value = e.target.value;
    let tempArr = this.state.participant_type?this.state.participant_type:[];
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      if(!newArray.includes('Any other Neurologic diagnosis')){
        this.setState({
          participant_type_any_other_neurologic_diagnosis_other_specification:"",
          participant_type_any_other_neurologic_diagnosis:"",
        })
      }
      this.setState({ participant_type: newArray });
    } else {
      tempArr.push(value);
      if(!tempArr.includes('Any other Neurologic diagnosis')){
        this.setState({
          participant_type_any_other_neurologic_diagnosis_other_specification:"",
          participant_type_any_other_neurologic_diagnosis:"",
        })
      }
      this.setState({ participant_type: tempArr });
    }
  }
  render() {
    const disabledDate = (current) => {
      // Disable selecting future years.
      return current && current.isAfter(dayjs(), "year");
    };
    return (
      <div>
        <div className="header">
          <h3>MEDICAL HISTORY</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2 input-heading">
                Smoking History <span className="text-danger">*</span>
              </label>
              <br />
              <Select
                onChange={(value) =>
                  this.setState({
                    smoking_history: value,
                    have_you_quit_smoking_in_the_past_year: "",
                  })
                }
                value={this.state.smoking_history}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              >
                <Option value="">Select Smoking History</Option>
                <Option value="I currently smoke">I currently smoke</Option>
                <Option value="I have never smoked">I have never smoked</Option>
                <Option value="I previously smoked">I previously smoked</Option>
              </Select>
              
            </div>
            <div className="form-group">
              <div className="d-flex justify-content-between col-lg-12">
                <label className="mb-2 input-heading">
                  Have you quit smoking in the past year?&nbsp; <span className="text-danger">*</span>
                </label>
              </div>
              <div className="form-group mt-3">
                <Radio.Group
                  onChange={(event) =>
                    this.setState({
                      have_you_quit_smoking_in_the_past_year:
                        event.target.value,
                    })
                  }
                  value={this.state.have_you_quit_smoking_in_the_past_year}
                  direction="vertical"
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
            </div>
            <div className="form-group">
              <div className="d-flex justify-content-between col-lg-12">
                <label className="mb-2 input-heading">
                  Do you have any allergies?&nbsp;
                  <span className="text-danger">*</span>
                </label>
              </div>
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    do_you_have_allergies: event.target.value,
                    allergies: [
                      {
                        id: 1,
                        name: "",
                      },
                    ],
                  })
                }
                value={this.state.do_you_have_allergies}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
              <br />
              {this.state.do_you_have_allergies == "Yes" && (
                <div className="col-lg-9 mt-2">
                  <div className="d-flex justify-content-between col-lg-12 mb-3">
                    <label className="mb-2 input-heading"></label>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      className="add_row_button"
                      onClick={() => this.add_new_allergy()}
                    >
                      {" "}
                      <box-icon name="plus-circle" color="#fff"></box-icon>{" "}
                      &nbsp;&nbsp;Add{" "}
                    </button>
                  </div>
                  <table className="medical-history-table">
                    <tr>
                      <th>
                        Allergies <span className="text-danger">*</span>
                      </th>
                      <th>Action</th>
                    </tr>
                    {this.state.allergies.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <input
                              type="text"
                              value={item.name}
                              style={{ height: 35 }}
                              onChange={(e) => this.update_allergy(e, item)}
                              maxLength={100}
                            />
                          </td>
                          <td>
                            <center>
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => this.remove_allergy(item.id)}
                              >
                                <box-icon
                                  size={"20px"}
                                  name="trash"
                                  color="red"
                                ></box-icon>
                              </span>
                            </center>
                          </td>
                        </tr>
                      );
                    })}
                  </table>
                </div>
              )}
            </div>
            <div className="form-group">
              <div className="d-flex justify-content-between col-lg-12">
                <label className="mb-2 input-heading">
                  Do you have any current prescriptions?&nbsp;
                  <span className="text-danger">*</span>
                </label>
              </div>
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    do_you_have_prescription: event.target.value,
                    prescriptions: [
                      {
                        id: 1,
                        name: "",
                      },
                    ],
                  })
                }
                value={this.state.do_you_have_prescription}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            {this.state.do_you_have_prescription=='Yes' && (
              <div className="form-group">
                <div className="d-flex justify-content-between col-lg-9">
                  <label className="mb-2 input-heading">
                    What are your current prescriptions?:
                    <span className="text-danger">*</span>
                  </label>
                  &nbsp;&nbsp;&nbsp;
                  <button
                    className="add_row_button"
                    onClick={() => this.add_new_prescription()}
                  >
                    {" "}
                    <box-icon name="plus-circle" color="#fff"></box-icon>{" "}
                    &nbsp;&nbsp;Add{" "}
                  </button>
                </div>
                <br />
                <div className="col-lg-9">
                  <table className="medical-history-table">
                    <tr>
                      <th>
                      Prescription<span className="text-danger">*</span>
                      </th>
                      <th style={{ width: 170 }}>Action</th>
                    </tr>
                    {this.state.prescriptions.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <input
                              type="text"
                              value={item.name}
                              style={{ height: 35 }}
                              onChange={(e) =>
                                this.update_prescription(e, item, "name")
                              }
                            />
                          </td>
                          <td>
                            <center>
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => this.remove_prescription(item.id)}
                              >
                                <box-icon
                                  size={"20px"}
                                  name="trash"
                                  color="red"
                                ></box-icon>
                              </span>
                            </center>
                          </td>
                        </tr>
                      );
                    })}
                  </table>
                </div>
              </div>
            )}
            <div className="form-group">
            <div className="d-flex justify-content-between col-lg-12">
                <label className="mb-2 input-heading">
                  Do you have any surgeries?&nbsp;
                </label>
              </div>
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    do_you_have_surgeries: event.target.value,
                    surgeries: [
                      {
                        id: 1,
                        type: "",
                        location: "",
                        date: "",
                      },
                    ],
                  })
                }
                value={this.state.do_you_have_surgeries}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
              <br/>
              {this.state.do_you_have_surgeries=='Yes' && (
                <div className="mt-3">
                  <div className="d-flex justify-content-between col-lg-9">
                    <label className="mb-2 input-heading">
                      Have you had any surgeries?:
                      <span className="text-danger">*</span>
                    </label>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      className="add_row_button"
                      onClick={() => this.add_new_surgery()}
                    >
                      {" "}
                      <box-icon name="plus-circle" color="#fff"></box-icon>{" "}
                      &nbsp;&nbsp;Add{" "}
                    </button>
                  </div>
                  <br />
                  <div className="col-lg-9">
                    <table className="medical-history-table">
                      <tr>
                        <th>
                          Surgery Type <span className="text-danger">*</span>
                        </th>
                        <th>
                          Surgery Location <span className="text-danger">*</span>
                        </th>
                        <th>
                          Surgery Year <span className="text-danger">*</span>
                        </th>
                        <th>Action</th>
                      </tr>
                      {this.state.surgeries.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                value={item.type}
                                style={{ height: 35 }}
                                onChange={(e) =>
                                  this.update_surgery(e, item, "type")
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={item.location}
                                style={{ height: 35 }}
                                onChange={(e) =>
                                  this.update_surgery(e, item, "location")
                                }
                              />
                            </td>
                            <td>
                              <DatePicker
                                disabledDate={disabledDate}
                                value={item.date}
                                onChange={(date) =>
                                  this.update_surgery(date, item, "date")
                                }
                                style={{
                                  width: "100%",
                                  height: 35,
                                  maxWidth: 500,
                                }}
                                picker="year"
                                format={"YYYY"}
                                placeholder="Select year"
                              />
                            </td>
                            <td>
                              <center>
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => this.remove_surgery(item.id)}
                                >
                                  <box-icon
                                    size={"20px"}
                                    name="trash"
                                    color="red"
                                  ></box-icon>
                                </span>
                              </center>
                            </td>
                          </tr>
                        );
                      })}
                    </table>
                  </div>
                </div>
              )}
            </div>
            <div className="col-lg-12">
              <label className="mb-2 input-heading">
                Do you have a history of any of the following?: <span className="text-danger">*</span>
              </label>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  ADHD/ADD
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ adhd: e.target.value })
                  }
                  value={this.state.adhd}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
                <div className="form-group">
                  <label className="input-heading" style={{ fontWeight: "400" }}>
                    Anxiety
                  </label>
                  <br />
                  <Radio.Group
                    onChange={(e) =>
                      this.setState({ anxiety: e.target.value })
                    }
                    value={this.state.anxiety}
                  >
                    <Space direction="horizontal">
                      <Radio value={"Yes"}>Yes</Radio>
                      <Radio value={"No"}>No</Radio>
                    </Space>
                  </Radio.Group>
                </div>
                <div className="form-group">
                  <label className="input-heading" style={{ fontWeight: "400" }}>
                    Asthma
                  </label>
                  <br />
                  <Radio.Group
                    onChange={(e) =>
                      this.setState({ asthma: e.target.value })
                    }
                    value={this.state.asthma}
                  >
                    <Space direction="horizontal">
                      <Radio value={"Yes"}>Yes</Radio>
                      <Radio value={"No"}>No</Radio>
                    </Space>
                  </Radio.Group>
                </div>
                <div className="form-group">
                  <label className="input-heading" style={{ fontWeight: "400" }}>
                    Autism Spectrum Disorder
                  </label>
                  <br />
                  <Radio.Group
                    onChange={(e) =>
                      this.setState({ autism_spectrum_disorder: e.target.value })
                    }
                    value={this.state.autism_spectrum_disorder}
                  >
                    <Space direction="horizontal">
                      <Radio value={"Yes"}>Yes</Radio>
                      <Radio value={"No"}>No</Radio>
                    </Space>
                  </Radio.Group>
                </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Bipolar disorder      
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ bipolar_disorder: e.target.value })
                  }
                  value={this.state.bipolar_disorder}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  {" "}
                  Brain Aneurysm
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ brain_aneurysm: e.target.value })
                  }
                  value={this.state.brain_aneurysm}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Cancer
                </label>
                <br />
                <Radio.Group
                  onChange={(e) => this.setState({ cancer: e.target.value })}
                  value={this.state.cancer}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Cognitive Impairment
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ cognitive_impairment: e.target.value })
                  }
                  value={this.state.cognitive_impairment}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>

              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Concussion (s)
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ concussion: e.target.value })
                  }
                  value={this.state.concussion}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>

              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  COPD
                </label>
                <br />
                <Radio.Group
                  onChange={(e) => this.setState({ copd: e.target.value })}
                  value={this.state.copd}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>

              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Dementia
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ dementia: e.target.value })
                  }
                  value={this.state.dementia}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Depression
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ depression: e.target.value })
                  }
                  value={this.state.depression}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Diabetes
                </label>
                <br />
                <Radio.Group
                  onChange={(e) => this.setState({ diabetes: e.target.value })}
                  value={this.state.diabetes}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Epilepsy
                </label>
                <br />
                <Radio.Group
                  onChange={(e) => this.setState({ epilepsy: e.target.value })}
                  value={this.state.epilepsy}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Muscle Disease
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ muscle_disease: e.target.value })
                  }
                  value={this.state.muscle_disease}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Migraines
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ migraines: e.target.value })
                  }
                  value={this.state.migraines}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>              
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Schizophrenia
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ schizophrenia: e.target.value })
                  }
                  value={this.state.schizophrenia}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Other
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ other_history_option: e.target.value })
                  }
                  value={this.state.other_history_option}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              {this.state.other_history_option == 'Yes' && (
                <div className="form-group">
                  <label className="input-heading">
                    Specification{" "}
                  </label>
                    <br />
                  <textarea
                    style={{
                      padding: 16,
                      fontSize: 18,
                    }}
                    rows={3}
                    placeholder="Specification..."
                    name="other_history_specification"                    
                    onChange={(e) => {
                      this.setState({
                        other_history_specification:
                          e.target.value,
                      });
                    }}
                    value={this.state.other_history_specification}
                  ></textarea>
                </div>
              )}
            </div>
            <div className="col-lg-12">
              <label className="mb-2 input-heading">Participant Type <span className="text-danger">*</span></label>
              <div className="form-group">
                <li className="pb-1 list-unstyled">
                  <Checkbox
                    value={'ALS'}
                    onChange={this.onChangeParticipantType}
                    checked={
                      this.state.participant_type.includes('ALS')
                        ? true
                        : false
                    }
                    style={{ fontSize:17}}
                  >
                    ALS
                  </Checkbox>
                </li>
                {this.state.participant_type.includes('ALS') && (
                  <div 
                    className="form-group"
                    style={{
                      paddingLeft: 25,
                      paddingTop: 10
                    }}
                  >
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          participant_type_als: e.target.value,
                        })
                      }
                      value={this.state.participant_type_als}
                    >
                      <Space direction="vertical">
                        <Radio value={"Known ALS Gene"}>Known ALS Gene</Radio>
                        <Radio value={"Unsure"}>Unsure</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                )}
                <li className="pb-1 list-unstyled">
                  <Checkbox
                    value={'ALS with Fronto-Temporal Dementia'}
                    onChange={this.onChangeParticipantType}
                    checked={
                      this.state.participant_type.includes('ALS with Fronto-Temporal Dementia')
                        ? true
                        : false
                    }
                    style={{ fontSize:17}}
                  >
                    ALS with Fronto-Temporal Dementia
                  </Checkbox>
                </li> 
                <li className="pb-1 list-unstyled">
                  <Checkbox
                    value={'Any other Neurologic diagnosis'}
                    onChange={this.onChangeParticipantType}
                    checked={
                      this.state.participant_type.includes('Any other Neurologic diagnosis')
                        ? true
                        : false
                    }
                    style={{ fontSize:17}}
                  >
                    Any other Neurologic diagnosis
                  </Checkbox>
                </li>
              </div>
              {this.state.participant_type.includes('Any other Neurologic diagnosis') && (
                <div className="form-group pl-4">
                  <label className="input-heading">
                    Any other Neurologic diagnosis:
                  </label><br/>
                  <Radio.Group
                    onChange={(e) =>
                      this.setState({
                        participant_type_any_other_neurologic_diagnosis: e.target.value,
                        participant_type_any_other_neurologic_diagnosis_other_specification:"",
                      })
                    }
                    value={this.state.participant_type_any_other_neurologic_diagnosis}
                  >
                    <Space direction="vertical">
                      <Radio value={"PLS"}>PLS</Radio>
                      <Radio value={"Dementia"}>Dementia</Radio>
                      <Radio value={"Muscular Disease"}>Muscular Disease</Radio>
                      <Radio value={"Other Motor Neuron Disease"}>Other Motor Neuron Disease</Radio>
                    </Space>
                  </Radio.Group>
                </div>
              )}
              {this.state.participant_type_any_other_neurologic_diagnosis=='Other Motor Neuron Disease' && (
                <div className="form-group pl-4">
                  <label className="input-heading">
                    Specification:
                  </label><br/>
                  <TextArea
                    style={{
                      padding: 16,
                      fontSize: 18,
                    }}
                    rows={4}
                    placeholder="Specification..."
                    name="participant_type_any_other_neurologic_diagnosis_other_specification"
                    value={
                      this.state.participant_type_any_other_neurologic_diagnosis_other_specification
                    }
                    onChange={(e) => {
                      this.setState({
                        participant_type_any_other_neurologic_diagnosis_other_specification:
                          e.target.value,
                      });
                    }}
                  />
                </div>
              )}
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button"
                  style={{
                    padding: "9px 15px 10px 20px",
                    width: "164px",
                    whiteSpace: "nowrap",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                  onClick={() => this.save(false)}
                >
                  Save for Later
                  <box-icon
                    name="save"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(true)}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(5)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                    width: "164px",
                    whiteSpace: "nowrap",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                  onClick={() => this.save(false)}
                >
                  Save for Later
                  <box-icon
                    name="save"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(true)}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
